import React from 'react';
import type { ServiceWorkspaceActiveSection } from '../../utils/navigationActiveState';

export type ServiceWorkspaceSection = ServiceWorkspaceActiveSection;

type ServiceWorkspaceShellProps = {
  activeSection?: ServiceWorkspaceSection;
  onSelect?: (nextSection: ServiceWorkspaceSection) => void;
  children: React.ReactNode;
  contentClassName?: string;
  containerClassName?: string;
  surfaceVariant?: 'default' | 'orders_focus';
};

const mergeClassNames = (...parts: Array<string | null | undefined | false>) =>
  parts.filter(Boolean).join(' ');

export const ServiceWorkspaceShell: React.FC<ServiceWorkspaceShellProps> = ({
  activeSection = 'orders',
  children,
  contentClassName,
  containerClassName,
  surfaceVariant = 'default',
}) => {
  const widthClassName =
    containerClassName || surfaceVariant !== 'orders_focus'
      ? 'max-w-6xl'
      : 'rs-wide-monitor-container';

  return (
    <div className="overflow-x-clip pb-[calc(env(safe-area-inset-bottom)+0.35rem)] pt-1 md:pb-5 md:pt-2">
      <div
        className={mergeClassNames(
          'mx-auto w-full overflow-x-hidden px-3 [padding-left:max(env(safe-area-inset-left),0.75rem)] [padding-right:max(env(safe-area-inset-right),0.75rem)] sm:px-4 md:px-5',
          widthClassName,
          containerClassName
        )}
      >
        <section
          data-testid="service-shell"
          data-active-workspace-section={activeSection}
          data-surface-variant={surfaceVariant}
          data-active-primary-module="service"
          className="relative overflow-hidden bg-transparent ring-0 shadow-none"
        >
          <div
            className={mergeClassNames(
              surfaceVariant === 'orders_focus' ? 'relative p-0' : 'relative p-0',
              contentClassName
            )}
          >
            {children}
          </div>
        </section>
      </div>
    </div>
  );
};

export default ServiceWorkspaceShell;
